import { jsx as _jsx } from "react/jsx-runtime";
export function Badge({ children, variant = "default", className = "", style, }) {
    const variantClasses = {
        default: "bg-duvi-surface text-duvi-text-secondary border border-duvi-border",
        success: "bg-duvi-success/10 text-duvi-success border border-duvi-success/20",
        warning: "bg-duvi-warning/10 text-duvi-warning border border-duvi-warning/20",
        error: "bg-duvi-destructive/10 text-duvi-destructive border border-duvi-destructive/20",
    };
    return (_jsx("span", { className: `inline-flex items-center px-2 py-0.5 rounded-[4px] ${variantClasses[variant] ?? variantClasses.default} ${className}`, style: { fontSize: "var(--text-xs)", ...style }, children: children }));
}
//# sourceMappingURL=Badge.js.map